import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { KBRoutes } from './Routes'
import { Base } from './Base'
import './i18n'

const app = document.getElementById('app')

// allows for #app element to have 100% height
if (app) {
    app.style.height = '100vh'
    app.style.display = 'flex'
}

ReactDOM.render(
    <BrowserRouter>
        <Base>
            <KBRoutes />
        </Base>
    </BrowserRouter>,
    app,
)
